import { defineStore } from 'pinia';
import type { PaginationState } from '~~/types/vuex/Pagination';

export const paginationStore = defineStore('pagination', {
  state: () => ({ currentPage: 1 as PaginationState['currentPage'] | null }),
  actions: {
    setCurrentPage(payload: PaginationState['currentPage'] | null) {

      this.currentPage = payload; 

    },
  },
});
